/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_Save_ButtonInputs */

const en_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Permissions`)
};

const fr_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les autorisations`)
};

const de_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen speichern`)
};

const it_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva autorizzazioni`)
};

const ru_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить разрешения`)
};

const es_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar permisos`)
};

const zh_cn2_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存权限`)
};

const ja_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存権限`)
};

const hi_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमतियाँ सहेजें`)
};

const pt_pt2_explorer_info_permissions_save_button = /** @type {(inputs: Explorer_Info_Permissions_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar permissões`)
};

/**
* | output |
* | --- |
* | "Save Permissions" |
*
* @param {Explorer_Info_Permissions_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_save_button = /** @type {((inputs?: Explorer_Info_Permissions_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_permissions_save_button(inputs)
	if (locale === "de") return de_explorer_info_permissions_save_button(inputs)
	if (locale === "it") return it_explorer_info_permissions_save_button(inputs)
	if (locale === "ru") return ru_explorer_info_permissions_save_button(inputs)
	if (locale === "es") return es_explorer_info_permissions_save_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_permissions_save_button(inputs)
	if (locale === "ja") return ja_explorer_info_permissions_save_button(inputs)
	if (locale === "hi") return hi_explorer_info_permissions_save_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_permissions_save_button(inputs)
	return en_explorer_info_permissions_save_button(inputs)
});